export default function getTimeStamp() {

    let date = new Date();

    // Hours part from the timestamp
    let hours = date.getHours();

    // Minutes part from the timestamp
    let minutes = "0" + date.getMinutes();

    // Will display time in 10:30 format
    return (hours + ':' + minutes.substr(-2));

}